<template>
  <div class="paint-app pixelated">
    <div class="background overlay stretchy halftone" style="z-index: -1"></div>
    <win-header title="MS-DOS Executive"></win-header>
    <dos-file-menu></dos-file-menu>
    <div class="file-window">
      <div class="drive-list">
        <div class="button drive-a"><label>A</label> <span class="drive-icon"></span></div>
        <div class="button drive-b"><label>B</label> <span class="drive-icon"></span></div>
        <div class="button drive-c selected"><label>C</label> <span class="drive-icon"></span></div>
        <div class="cwd">
          C: \WINDOWS
        </div>
      </div>

      <div class="file-list">
        <div class="col1">
          <label>ABC.TXT</label>
          <label>CALC.EXE</label>
          <label>CALENDAR.EXE</label>
          <label>CARDFILE.EXE</label>
          <label>CLIPBRD.EXE</label>
          <label>CLOCK.EXE</label>
          <label>CONTROL.EXE</label>
          <label>COURA.FON</label>
          <label>COURB.FON</label>
          <label>DOTHIS.TXT</label>
          <label>HELVA.FON</label>
          <label>HELVB.FON</label>
          <label>MODERN.FON</label>
          <label>MSDOS.EXE</label>
          <label>NOTEPAD.EXE</label>
          <label class="selected" v-on:click="PAINT">PAINT.EXE</label>
          <label>PRACTICE.DOC</label>
          <label>README.DOC</label>
        </div>
        <div class="col2">
          <label>REVERSI.EXE</label>
          <label>ROMAN.FON</label>
          <label>SCRIPT.FON</label>
          <label>SPOOLER.EXE</label>
          <label>TERMINAL.EXE</label>
          <label>TMSRA.FON</label>
          <label>WIN.COM</label>
          <label>WIN.INI</label>
          <label>WIN100.BIN</label>
          <label>WIN100.OVL</label>
          <label>WINOLDAP.GRB</label>
          <label>WINOLDAP.MOD</label>
          <label>WRITE.EXE</label>
        </div>
        <div class="column small-8"></div>
      </div>



    </div>
    <bottom-bar></bottom-bar>
  </div>
</template>

<style lang="scss" scoped>
  .file-window {
    background-color: #fff;
    height: 315px;
    border-bottom: 1px solid #000;
    display: block;

  }

  .drive-list {
    padding: 4px 4px;

    > div {
      float: left;
      margin: 0 4px;

    }

    .button {
      border: none;
      //width: 60px;
      height: 19px;

      label {
        display: block;
        float: left;
        width: auto;
        padding: 0;
        margin: 0 4px;
      }

      .drive-icon {
        display: inline-block;
        width: 40px;
        height: 15px;
        background-image: url(../assets/drive.png);
        background-position: -1px -1px;
        margin: 2px 2px -1px 0;
      }

      &.selected {
        background-color: #000;
        color: #fff;
        cursor: pointer;
        .drive-icon {
          background-position: -43px -1px;
        }
      }
    }
  }



  .file-list {
    clear: both;
    > div {
      width: 120px;
      float: left;
      line-height: 10px;
      padding: 4px 4px;

      label {
        display: block;
        margin: -1px 0;
        padding: 0 4px;

        &.selected {
          background-color: #000;
          color: #fff;
          border-bottom: 1px dotted #000;
          background-clip: padding-box;
        }
      }
    }
  }

  .blink {
    label.selected {
      border-color: transparent !important;
    }
  }

</style>
<script>

  import BottomBar from './BottomBar.vue'
  import WinHeader from './WinHeader.vue'
  import DosFileMenu from './DosFileMenu.vue'

  import _ from 'lodash'

  import config from '../data/config';
  import state from '../data/state';

  export default{
    data(){
      return {
        config: config,
        state: state,
      }
    },
    components: {
      BottomBar,
      WinHeader,
      DosFileMenu,

    },
    methods: {
      // App level commands
      runCommand(e) {
        const $btn = $(e.target);
        const cmd = $btn.data('cmd');
        const arg = $btn.data('arg');
        if (cmd && _.isFunction(this[cmd])) {
          //console.log('Running App Command', cmd, arg);
          this[cmd].call(this, arg);
        } else {
          if (state && _.isFunction(state[cmd])) {
            //console.log('Running State Command', cmd, arg);
            state[cmd].call(state, arg);
          } else {
            //console.log('Command not found', cmd);
          }
        }
      },

      PAINT() {
        console.log('PAINT', state);
        state.currentView = 'paint-app';
      },

      blink() {
        $(this.$el).toggleClass('blink');
      }

    },
    ready() {
      $(this.$el).on('click', '*[data-cmd]', this.runCommand);
      if(!config.devMode) this.blinkInt = setInterval(this.blink, 600);

      // Transition In
      var $background = $('.background', this.$el);
      //var $background2 = $('.background2', this.$el);

      var $children = [
        $('.top-bar', this.$el),
        $('.menu-bar', this.$el),
        $('.file-window', this.$el),
        $('.drive-list', this.$el),
        $('.file-list', this.$el)
      ];

      //console.log('Intro Paint');

      _.each($children, ($child, i )=> {
        let delay = .75 + i * (.2 + Math.random() * .1);
        TweenLite.set($child, { opacity: 0});
        TweenLite.to($child, .12, { delay: delay, opacity: 1.0});
      });

      TweenLite.set($background, {opacity: 1.0});
      TweenLite.to($background, .5, {opacity: 0, delay: 4});
//
//      TweenLite.set($background2, {opacity: 0});
//      TweenLite.to($background2, .15, {opacity: 1, delay: 1.25});
//      TweenLite.to($background2, .5, {opacity: 0, delay: 4});

      this.tweenedThings = $children.concat($background);

    },
    onBeforeDestroy() {
      $(this.$el).off('click', '*[data-cmd]', this.runCommand);
      clearInterval(this.blinkInt);
      if(this.tweenedThings) {
        TweenLite.killTweensOf(this.tweenedThings)
      }
    }

  }

</script>



// WEBPACK FOOTER //
// DosExecutive.vue?6d2c61d8